import React from 'react';
import FlowModelSummary from '../FlowModelList/FlowModelSummary';
import IPublishedFlowModel from '@Shared.Angular/@types/core/contracts/queryModel/flowModels/publishedFlowModel';
import { Guid } from '@Shared.Angular/@types/guid';

type Props = {
  flowModels: IPublishedFlowModel[];
  isMobile: boolean;
  onFlowModelClicked?: (flowModelId: string) => void;
};

const FlowModelSummaryList = ({
  flowModels,
  isMobile,
  onFlowModelClicked
}: Props) => {
  const handleFlowModelClick = (id: Guid) => {
    onFlowModelClicked?.(id);
  };

  return (
    <ul>
      {flowModels.map((flowModel) => (
        <li key={flowModel.id}>
          <FlowModelSummary
            flowModelSummary={flowModel}
            isMobile={isMobile}
            onFlowModelClick={handleFlowModelClick}
          />
        </li>
      ))}
    </ul>
  );
};

export default FlowModelSummaryList;
